var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountSharedLayout',{staticClass:"AccountExpiredView"},[_c('h1',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        AccountExpiredView\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }